import { BUSINESS, IMAGES } from "@/constants";

export const Hero = () => {
    return (
        <section id="home" data-testid="hero-section" className="relative">
            <div className="absolute inset-0">
                <img
                    src={IMAGES.hero}
                    alt="Residential landscape with palm trees in Florida"
                    className="h-full w-full object-cover"
                />
                <div className="absolute inset-0 bg-black/50" />
            </div>
            <div className="relative max-w-6xl mx-auto px-4 sm:px-6 py-24 sm:py-32 lg:py-40">
                <p className="text-sm font-medium uppercase tracking-widest text-white/80 mb-4">
                    Sod &amp; Ornamental Nursery — Boynton Beach, Florida
                </p>
                <h1
                    data-testid="hero-heading"
                    className="font-heading font-bold tracking-tight text-white text-4xl sm:text-5xl lg:text-6xl max-w-3xl"
                >
                    {BUSINESS.name}
                </h1>
                <p
                    data-testid="hero-description"
                    className="mt-6 text-base md:text-lg text-white/90 max-w-2xl"
                >
                    A sod and ornamental nursery business based in Boynton Beach, Florida.
                </p>
                <a
                    href="/#contact"
                    data-testid="hero-contact-cta"
                    className="inline-block mt-10 rounded-full bg-accent text-accent-foreground font-medium px-8 py-3 hover:opacity-90 transition-opacity"
                >
                    Contact Us
                </a>
            </div>
        </section>
    );
};
